import { useContext } from 'react';

import { QBSLevelItemSelectionContext } from './qbs-level-item-selection-provider';

export const useQBSLevelItemSelection = () => {
  const context = useContext(QBSLevelItemSelectionContext);
  if (context === undefined) {
    throw new Error('useQBSLevelItemSelection must be used within a QBSLevelItemSelectionProvider');
  }
  return context;
};
